import { Controller } from "@hotwired/stimulus"

// Shows who liked a story or comment in a centered modal with search.
export default class extends Controller {
  static values = { url: String }
  static targets = ["trigger", "panel", "listContainer", "search"]

  connect() {
    this.boundKeydown = (e) => { if (e.key === "Escape") this.close() }
    this.users = []
  }

  disconnect() {
    this.close()
  }

  toggle(e) {
    e.preventDefault()
    e.stopPropagation()
    if (this.panelTarget.classList.contains("hidden")) {
      this.open()
    } else {
      this.close()
    }
  }

  open() {
    if (!this.hasPanelTarget || !this.urlValue) return
    const count = this.triggerTarget.getAttribute("data-likes-count")
    if (count === "0" || !count) return
    this.load().then(() => {
      this.panelTarget.classList.remove("hidden")
      if (this.hasSearchTarget) {
        this.searchTarget.value = ""
        this.searchTarget.focus()
      }
      this.renderList(this.users)
      document.addEventListener("keydown", this.boundKeydown)
    })
  }

  close() {
    if (!this.hasPanelTarget) return
    this.panelTarget.classList.add("hidden")
    document.removeEventListener("keydown", this.boundKeydown)
  }

  stopPropagation(e) {
    e.stopPropagation()
  }

  filter() {
    if (!this.hasSearchTarget || !this.hasListContainerTarget) return
    const q = this.searchTarget.value.trim().toLowerCase()
    const filtered = q
      ? this.users.filter((u) => {
          const name = (u.name || "").toLowerCase()
          const username = (u.username || "").toLowerCase()
          return name.includes(q) || username.includes(q)
        })
      : this.users
    this.renderList(filtered)
  }

  async load() {
    const res = await fetch(this.urlValue, { headers: { Accept: "application/json" } })
    if (!res.ok) return
    this.users = await res.json()
  }

  renderList(users) {
    if (!this.hasListContainerTarget) return
    const hasSearch = this.hasSearchTarget && this.searchTarget.value.trim().length > 0
    if (users.length === 0) {
      const msg = hasSearch ? "No matches for your search" : "No one yet"
      this.listContainerTarget.innerHTML = `<p class="text-sm text-ink-muted py-4 text-center">${msg}</p>`
      return
    }
    this.listContainerTarget.innerHTML = `<ul class="space-y-1.5">${users.map((u) => this.userItem(u)).join("")}</ul>`
  }

  userItem(u) {
    const name = (u.name || u.username || "User").trim()
    const url = `/@${encodeURIComponent(u.username)}`
    const avatar = u.avatar_url
      ? `<img src="${this.escapeAttr(u.avatar_url)}" alt="" class="h-8 w-8 rounded-full object-cover shrink-0" />`
      : `<span class="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-ink/10 text-sm font-semibold text-ink">${this.escapeHtml((name.slice(0, 2) || "?").toUpperCase())}</span>`
    return `<li><a href="${this.escapeAttr(url)}" data-turbo-frame="_top" class="flex items-center gap-3 rounded-lg px-2 py-2 text-sm text-ink hover:bg-ink/5 transition-colors">${avatar}<span>${this.escapeHtml(name)}</span><span class="text-ink-muted text-xs">@${this.escapeHtml(u.username || "")}</span></a></li>`
  }

  escapeHtml(s) {
    const div = document.createElement("div")
    div.textContent = s
    return div.innerHTML
  }

  escapeAttr(s) {
    return String(s).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/</g, "&lt;").replace(/>/g, "&gt;")
  }
}
